// test1010
(1010 && 0);
